var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 116.754 42.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "OrangeButton",
    d: "M22.631-.591,16.38,4.984l.727,29.557,5.3,7.35L125.5,39.8l4.5-9.257L133.135,7.65,125.6.075Z",
    transform: "translate(-16.38 0.591)",
    fill: "#c78b43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeButton);
export default __webpack_public_path__ + "static/media/OrangeButton.1b35aebbd026a9f7764c60cb65ff54ec.svg";
export { ForwardRef as ReactComponent };